export default __webpack_public_path__ + "static/media/gribble-placeholder.0bd8251f.png";